import styled from 'styled-components';

export const SliderContainer = styled.div`
    width: 100%;
    padding: 4px 0;
    height: 40px;
`;

export const Ball = styled.div`
    height: 16px;
    width: 16px;
    border-radius: 8px;
    background-color: ${({ isActive }) => isActive ? '#D73E67' : '#B5B5B5'};
`;
